import React from 'react';
import CustomBox from '../CommonComp/CustomBox/CustomBox';
import AllImages from './AllImages';
import ImagesGroup from './ImagesGroup';
import SoldImages from './SoldImages';
import SuspendedImages from './SuspendedImages';
import StarImages from './StarImages';
import ShootIdListing from './ShootIdListing';
import ExclusiveImages from './ExclusiveImages';
import AllImagesDesc from './AllImagesDesc';
import HighestViewed from './HighestViewed';
import  ImageLink  from './ImageLink';
import SearchImageByKeyword from './SearchImageByKeyword';


function ImageTabBody({ activeTab }) {
  return (
    <>
      {activeTab != 3 && activeTab !== 12 && (
        <CustomBox
          padding={0}
          sx={{
            minHeight: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: activeTab != 3 && 'center',
            alignItems: activeTab != 11 && 'center',
          }}
        >
          {activeTab == 1 && <AllImages />}
          {activeTab == 2 && <StarImages />}
          {activeTab == 4 && <SoldImages />}
          {/* {activeTab == 5 && <SoldImagesPending />} */}
          {activeTab == 6 && <ImagesGroup />}
          {activeTab == 7 && <SuspendedImages />}
          {activeTab == 8 && <ShootIdListing />}
          {activeTab == 9 && <AllImagesDesc />}
          {activeTab == 10 && <HighestViewed />}
          {activeTab == 11 && <SearchImageByKeyword />}
        </CustomBox>
      )}
      {activeTab == 3 && <ExclusiveImages />}
      {activeTab == 12 && <ImageLink />}
    </>
  );
}

export default ImageTabBody;
